import React from "react"
import { useStageFunnel } from "./context/StageFunnelContext"
import FunnelAppDownload from "../brevet/components/FunnelAppDownload"

const StageAppDownloadScreen = () => {
    const { state } = useStageFunnel()

    return (
        <FunnelAppDownload
            firstname={state.studentFirstname}
            trackingSource="stage_download_app"
            hideLogo
        />
    )
}

export default StageAppDownloadScreen
